
































import { PropType } from 'vue';
import { computed, defineComponent, onMounted, toRefs, ref, watch } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import Isp from './index';
import { trackEvent } from './../../../utils/index';
import { useISPInfoApi } from '@tt4b/ttam-hooks';
import ALink from '@/components/common/a-link/a-link.vue';

const name = 'ttam-isp-compose';
export default defineComponent({
  name,
  components: {
    TtamIsp: Isp.TtamIsp,
    ALink,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    countryIds: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    selectedLabel: {
      type: Function,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, countryIds } = toRefs(props);
    const ispInfoList = ref([]);

    const _isp = computed({
      get: () => adgroupData.value.internetServiceProviders,
      set: val => {
        emit('change', val);
        emit('input', val);
      },
    });
    const { loadData, ispList } = Isp.useDataSource();

    const _ispList = computed(() => {
      const _list = JSON.parse(JSON.stringify(ispList.value));
      if (_isp.value?.length >= 20) {
        return _list.map(item => {
          if (!_isp.value.includes(item.value)) {
            item.disabled = true;
          }
          return item;
        });
      }
      return _list;
    });

    const resetIsp = countryIds => {
      // 重新拉取List
      loadData({
        queryParams: {
          countryIds,
        },
        scene: 1,
      });
    };

    const ispStrList = computed(() => (ispInfoList.value || []).map(item => item.label).join(','));

    onMounted(() => {
      if (countryIds.value.length > 0) {
        resetIsp(countryIds.value);
      }
      if (adgroupData.value.internetServiceProviders?.length === 0) {
        return;
      }
      (async () => {
        ispInfoList.value = await useISPInfoApi({
          strIds: adgroupData.value.internetServiceProviders,
          scene: 1,
        });
        const ispInfoValueList = (ispInfoList.value || []).map(listItem => listItem.value);
        _isp.value = _isp.value.filter(item => !ispInfoValueList.includes(item));
      })();
    });

    // 监听countryIds变化
    watch([countryIds], (value, oldValue) => {
      // 重新拉取List
      if (JSON.stringify(value) !== JSON.stringify(oldValue)) {
        resetIsp(countryIds.value);
      }
    });

    const iconHoverTrack = () => trackEvent('adgroup_operator_isp_tips_hover');
    return {
      name,
      _isp,
      ispList,
      _ispList,
      iconHoverTrack,
      resetIsp,
      ispInfoList,
      ispStrList,
    };
  },
});
